var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "section",
        {
          staticClass: "video-bar d-flex bg-black justify-content-center",
          attrs: { id: "qna-video" }
        },
        [
          _c("div", { staticClass: "content__column" }, [
            _c("div", { staticClass: "iframe__wrapper" }, [
              _vm.videoId
                ? _c("iframe", {
                    staticClass: "iframe border border-grey-900",
                    attrs: {
                      src:
                        "https://www.youtube.com/embed/" +
                        _vm.videoId +
                        "?autoplay=1"
                    }
                  })
                : _vm._e()
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }